<div class="d-grid gap-2">
	<button type="button" class="btn btn-primary" (click)="showAdd = !showAdd">Dodaj nowego nadawcę</button>
</div>

<div class="card container" *ngIf="showAdd">
	<form (submit)="add()" class="card-body">
		<div class="form-floating mb-3">
			<input class="form-control" name="name" [(ngModel)]="new.name" id="name" />
			<label for="name">Nazwa</label>
		</div>
		<div class="form-floating mb-3">
			<textarea class="form-control" name="address" [(ngModel)]="new.address" id="address" cols="2"></textarea>
			<label for="address">Adres</label>
		</div>
		<div class="d-grid">
			<button class="btn btn-primary">Zapisz</button>
		</div>
	</form>
</div>

<table class="table">
	<thead>
		<tr>
			<th>Nazwa</th>
			<th>Adres</th>
			<th></th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of senders">
			<td>
				<input
					class="form-control"
					name="name"
					[(ngModel)]="item.name"
					[readonly]="!item?.editable"
					[disabled]="!item?.editable"
				/>
			</td>
			<td>
				<input
					class="form-control"
					name="address"
					[(ngModel)]="item.address"
					[readonly]="!item?.editable"
					[disabled]="!item?.editable"
				/>
			</td>
			<td>
				<button type="button" class="btn btn-primary me-2" (click)="edit(item)" *ngIf="!item?.editable">
					Edytuj
				</button>
				<button type="button" class="btn btn-danger" (click)="delAsk(item)" *ngIf="!item?.editable">
					Usuń
				</button>
				<button type="button" class="btn btn-primary" (click)="submit(item)" *ngIf="item?.editable">
					Zapisz
				</button>
			</td>
		</tr>
	</tbody>
</table>
